import { authAxiosInstance } from "../../base/functions";

type ListStoreRequest = {};
type ListStoreResponse = { id: number; name: string };

export async function AdminListStore(req: ListStoreRequest): Promise<ListStoreResponse> {
  const axios = await authAxiosInstance();
  return axios.post("/AdminListStore", req).then((r) => r.data);
}
